import ApplicationIcon from './ApplicationIcon';
export default ApplicationIcon;
